<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Expedição Romaneio",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Loader, Layout, PageHeader },
  data() {
    return {
      title: "Editar Expedição Romaneio",
      items: [
        {
          text: "Romaneios",
          href: "/wmsromaneios/list",
        },
        {
          text: "Editar Expedição Romaneio",
          active: true
        }
      ],

      idData: 0,
      updating: true,
      updatingListas: false,
      wmsRomaListData: null,
      wmsRomaData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },

      movData: {},
      wmsOsItemData: {},
      wmsRomaOsListData: {},
      wmsRomaOsListDataLidas: {},
      wmsOsItensSepData: {},
      wmsOsVolumesData: {},
      wmsOsVolumeData: {},
      transpData: {},

      submitted: false,
      errosValid: null,
      tipoConferencia: 'A',
      tipoVolume: 'A',
      showModalVolume: false,
      loadingWmsVolume: false,
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      totalEtiquetas: 0,
      totalEtiquetasLidas: 0


    }
  },
  created() {



  },
  mounted() {
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.produto.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })


    console.log('mounted_wmsOs_editar_transp_0')
    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()

    }else{
      this.title = `Criando Nova OS`
      this.updating = false
    }
  },

  methods: {

    informouEtiqueta() {
      console.log('informouEtiqueta')
      let existeEtiqDisp = false
      let idVolume = 0
      this.wmsRomaOsListData.forEach((value) => {
        if (value.etiqueta === this.wmsOsVolumeData.etiqueta) {
          existeEtiqDisp = true
          idVolume = value.id
        }
      })

      if (this.wmsOsVolumeData.etiqueta && existeEtiqDisp === true) {
        console.log('vai')
        api.post(`${getBaseUrl()}api/wmsosromaconfemb`, {
          'iddata': idVolume
        }).then((res) => {

          console.log('then axios romaConf')
          console.log(res.data)

          this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[0])
          this.wmsRomaOsListDataLidas = this.filtrarDespachados(res.data[0])
          this.wmsOsVolumeData.etiqueta = ''

          if (this.wmsRomaOsListData.length === 0) {
            this.wmsRomaData.status = 'FN'

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Solicitação automática de coleta será realizada!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              api.post(`${getBaseUrl()}api/solicitacoleta`, {
                idData: this.idData
              }).then((res) => {
                console.log('then axios disparaColeta')
                console.log(res.data)

                if(res.data.success === true){
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: res.data.mensagem,
                    showConfirmButton: false,
                    timer: 2500
                  })
                }else{
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: res.data.mensagem,
                    showConfirmButton: true,
                    timer: 10000
                  })
                }
              })
            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Etiqueta não disponível, favor corrigir e tentar novamente.",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    informouEtiquetaNova() {
      console.log('informouEtiquetaNova')
      let existeEtiqDisp = false
      let wmsosromaneio_atual = {}

      const inputEtiqueta = this.wmsOsVolumeData.etiqueta
      console.log(`inputEtiqueta: ${inputEtiqueta}`)
      const encontradaEtiqueta = this.wmsRomaOsListData.find((value) => {
        return (
            value.etiqueta.includes(inputEtiqueta) ||
            value.etiqueta.includes(inputEtiqueta.replace(/^0/, '')) ||
            inputEtiqueta.includes(value.etiqueta) ||
            inputEtiqueta.replace(/^0/, '').includes(value.etiqueta)
        )
      })

      if(encontradaEtiqueta){
        existeEtiqDisp = true
        wmsosromaneio_atual = encontradaEtiqueta
      }

      /* CASO FLUXO ANTERIOR ATENDER - DELETAR ESSE TRECHO POSTERIORMENTE*/
      /*this.wmsRomaOsListData.forEach((value) => {
        if (value.etiqueta === this.wmsOsVolumeData.etiqueta) {
          existeEtiqDisp = true
          wmsosromaneio_atual = value
        }
      })*/

      //Verificando se etiqueta já está na lista de lidas
      this.wmsRomaOsListDataLidas.forEach((value) => {
        if (value.etiqueta === this.wmsOsVolumeData.etiqueta) {
          existeEtiqDisp = false
        }
      })

      //Adicionando à lista dos itens lidos
      if (existeEtiqDisp) {
        this.wmsRomaOsListDataLidas.push(wmsosromaneio_atual)

        let todelete_wmsromaetiqueta = this.wmsRomaOsListData.findIndex(item => item.etiqueta === wmsosromaneio_atual.etiqueta)

        if(todelete_wmsromaetiqueta !== -1){
          this.wmsRomaOsListData.splice(todelete_wmsromaetiqueta, 1)
        }
        this.totalEtiquetasLidas = this.wmsRomaOsListDataLidas.length

        if(this.wmsRomaOsListData.length === 0){
          console.log('finalizar expedição...')

          api.post(`${getBaseUrl()}api/wmsosromaconfembnova`, {
            'iddata': this.idData,
            'lista_etiquetas': this.wmsRomaOsListDataLidas
          }).then((res) => {
            console.log('then wmsosromaconfembnova')
            console.log(res.data)

            let success = res.data[0]
            if(success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {

                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Solicitação automática de coleta será realizada!",
                  showConfirmButton: false,
                  timer: 2000
                }).then(() => {

                  api.post(`${getBaseUrl()}api/solicitacoleta`, {
                    idData: this.idData
                  }).then((res) => {
                    console.log('then axios disparaColeta')
                    console.log(res.data)

                    if(res.data.success === true){
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: res.data.mensagem,
                        showConfirmButton: false,
                        timer: 2500
                      })
                    }else{
                      Swal.fire({
                        position: "center",
                        icon: "error",
                        title: res.data.mensagem,
                        showConfirmButton: true,
                        timer: 10000
                      })
                    }
                  })
                })

                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro no processo de finalização dos volumes atuais!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }else{
          //Limpando input
          this.wmsOsVolumeData.etiqueta = ''
          this.$refs.etiqueta.focus()

        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Etiqueta não disponível, favor corrigir e tentar novamente.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    informouQtdVolume(){
      console.log('informouQtdVolume')
      this.$refs.pesovolume.focus()

    },

    informouPeso() {
      console.log('informouPeso')
      this.confirmarVolume()

    },

    imprimirEtiqueta() {
      console.log('imprimirEtiqueta')

    },

    finalizar() {
      console.log('finalizar')

      if (this.wmsRomaOsListDataLidas.length > 0) {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Finalizar Conferência",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            // console.log(result.value)
            // console.log('vai')
            // this.wmsOsItemData['idwmsos'] = this.idData
            // this.updatingListas = true
            //
            api.post(`${getBaseUrl()}api/wmsosromaconfemb`, {
              'iddata': this.idData,
            }).then((res) => {
              console.log('then axios separar2')
              console.log(res.data)
              this.wmsRomaData = res.data[0]

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          }
        })

      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade pendente de separação deve ser igual a zero, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }



    },

    finalizarNova(){
      // console.log('finalizarNova')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Finalizar Conferência",
        text: "Se permanecerem volumes pendentes, você poderá retornar para separação posteriormente!",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/wmsosromaconfembnova`, {
            'iddata': this.idData,
            'lista_etiquetas': this.wmsRomaOsListDataLidas
          }).then((res) => {
            console.log('then axios finalizarNova')
            console.log(res.data)

            let success = res.data[0]
            if(success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro no processo de finalização dos volumes atuais!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })
    },

    abrirOutraOS(idos) {

      const routeData = this.$router.resolve(`${idos}`)
      window.open(routeData.href, '_blank')

      //$router.push(`/wmsos/saidaeditarnova/${data.id}`)

    },

    separarTodos(){
      console.log('separar todos wmsosvolume...')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Deseja realmente separar todos os volumes de uma só vez?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if(result.value){
          api.post(`${getBaseUrl()}api/wmsosromaconftodos`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separarTodos')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                text: 'Solicitação de coleta será realizado automaticamente!',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000
              }).then(() => {

                api.post(`${getBaseUrl()}api/solicitacoleta`, {
                  'idData': this.idData
                }).then((res) => {
                  console.log('then axios disparaColeta')
                  console.log(res.data)

                  if(res.data.success === true){
                    Swal.fire({
                      position: "top-end",
                      icon: "success",
                      title: res.data.mensagem,
                      showConfirmButton: false,
                      timer: 3000
                    })
                  }else{
                    Swal.fire({
                      position: "center",
                      icon: "error",
                      title: res.data.mensagem,
                      showConfirmButton: true,
                      timer: 10000
                    })
                  }
                })

                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Processo de separação de todos falhou!",
                text: res.data.message,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })
    },

    reiniciar() {
      console.log('reiniciar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          console.log(result.value)
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosromareinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2')
            console.log(res.data)



            this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[0])
            this.wmsRomaOsListDataLidas = {};
            this.wmsRomaData.status = 'EL'

            this.updatingListas = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })



          })


        }
      })

    },

    clicouEtiqueta(etiq){
      // console.log('clicouEtiqueta')
      // console.log(etiq)

      this.wmsOsItemData.produto = etiq

      this.$refs.etiqueta.focus()
      this.wmsOsVolumeData.etiqueta = etiq

      // Swal.fire({
      //   position: "top-end",
      //   icon: "info",
      //   title: "Código copiado para área de transferência.",
      //   showConfirmButton: false,
      //   timer: 1500
      // })

    },

    informouProduto() {
      console.log('informouProduto')
      this.wmsRomaOsListData.forEach((value) => {

        if (value.produto === this.wmsOsItemData.produto) {
          console.log(value)
          this.wmsOsItemData.descprod = value.descprod

          this.wmsOsItemData.qtd = value.qtddisp

          if (this.tipoConferencia === 'A') {
            this.wmsOsItemData.qtdlida = 1
            // this.$refs.qtdlida.focus()
            this.informouQtdLida()
          } else {
            this.wmsOsItemData.qtdlida = value.qtddisp
            this.$refs.qtdlida.focus()
          }

        }
      });
    },

    informouQtdLida() {
      console.log('informouQtdLida')
      console.log(this.wmsOsItemData.qtdlida)
      console.log(this.wmsOsItemData.qtd)

      if ( !this.wmsOsItemData.qtdlida || !this.wmsOsItemData.qtd || this.wmsOsItemData.qtdlida > this.wmsOsItemData.qtd) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        console.log('vai')

        this.updatingListas = true

        this.wmsOsItemData['idwmsos'] = this.idData

        api.post(`${getBaseUrl()}api/wmsositconfseptransp`, {
          'movItemSepData': this.wmsOsItemData
        }).then((res) => {
          console.log('then axios separar2')
          console.log(res.data)



          this.wmsOsItensSepData = res.data[0]
          this.wmsRomaData = res.data[1]
          this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[2])


          this.updatingListas = false

          this.$refs.produto.focus()
          this.wmsOsItemData.produto = ''
          this.wmsOsItemData.qtd = 0
          this.wmsOsItemData.qtdlida = 0

          // this.updating = false
          // this.$refs.produto.focus()

          // this.movCompraItemSepDataList = res.data[0]
          // this.movCompraItemData = res.data[1]
          // this.loadingWmsEnder = false
          //
          // let valorSeparado = 0
          // this.movCompraItemSepDataList.forEach((value) => {
          //   valorSeparado += value.qtd
          // })
          // this.movCompraItemSepDataDisp = this.movCompraItemData.qtd - valorSeparado

          // if (this.movCompraItemSepDataDisp === 0){
          //   this.showModalSepara = false
          //
          //   Swal.fire({
          //     position: "top-end",
          //     icon: "success",
          //     title: "Separação salva com sucesso!",
          //     showConfirmButton: false,
          //     timer: 1500
          //   })
          //   this.carregarDadosItens()
          //
          // } else {
          //   // this.movCompraItemSepData.qtd = this.movCompraItemSepDataDisp
          //   // this.movCompraItemSepData.palete = ''
          //   // this.movCompraItemSepData.endwms = ''
          //   // this.$refs.palete.focus()
          // }




          // this.movCompraItemData.stswms = 'SE'
          //
          //this.movCompraData = res.data
          // this.idData = res.data[0].id
          // this.$router.replace({ path: `/movcompra/editar/${this.idData}` })
          // this.carregarDados()
          // this.carregarDadosItens()
          // this.showModalSepara = false
          //

        })



      }


    },

    filtrarDisponiveis(arrayEntr) {
      //this.wmsRomaOsListData = res.data[6]
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        // console.log(value)
        if (!value.dtconfer){
          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    filtrarDespachados(arrayEntr) {
      //this.wmsRomaOsListData = res.data[6]
      console.log('filtrarDespachados')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        // console.log(value)
        if (value.dtconfer){
          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    carregarDados(){
      api.get(`${getBaseUrl()}api/wmsromaexped`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsRoma')
        console.log(res.data)
        console.log(JSON.stringify(res.data))

        this.wmsRomaData = res.data[0]
        this.wmsRomaListData = res.data[4]
        this.wmsOsVolumesData = res.data[1]

        this.transpData = res.data[2]

        this.movData = res.data[5]


        this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[6])
        this.totalEtiquetas = this.wmsRomaOsListData.length
        //console.log(`Total de etiquetas: ${this.totalEtiquetas}`)

        this.wmsRomaOsListDataLidas = this.filtrarDespachados(res.data[6])
        this.totalEtiquetasLidas = this.wmsRomaOsListDataLidas.length
        //console.log(`Total de etiquetas Lidas: ${this.totalEtiquetasLidas}`)

        this.wmsOsItensSepData = res.data[7]

        //
        // let totalVols = 0
        // let pesoVols = 0
        // this.wmsOsVolumesData.forEach((value) => {
        //   totalVols += value.qtd
        //   pesoVols += value.peso
        // });
        //
        // this.somaQtdVolumes = totalVols
        // this.somaPesoVolumes = pesoVols

        // if (this.wmsRomaOsListData && this.wmsRomaOsListData.length > 0){
        //   this.wmsRomaOsListData.forEach((value) => {
        //     if (value.imgs) {
        //       let imgTrat = value.imgs.split(',')
        //       value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
        //       let valor = parseFloat(value.vlrtotalliq)
        //       this.valorTotalItens += valor
        //     }
        //   });
        // }

        this.idData = this.wmsRomaData.id
        this.title = `Editar Expedição de Romaneio (${this.wmsRomaData.id}) ${this.transpData != null ? this.transpData.nome : ''}`
        this.updating = false
      })
    },

    confirmarVolume() {
      console.log('confirmarVolume')
      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0){
        this.loadingWmsVolume = true
        // this.loadingWmsEnder = true
        // console.log(this.wmsOsItemSepData.produto)
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          'idwmsos': this.idData,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
        }).then((res) => {
          console.log('then axios conf_vol')
          console.log(res.data)
          this.wmsOsVolumesData = res.data[0]
          let totalVols = 0
          let pesoVols = 0
          this.wmsOsVolumesData.forEach((value) => {
            totalVols += value.qtd
            pesoVols += value.peso
          });
          this.somaQtdVolumes = totalVols
          this.somaPesoVolumes = pesoVols
          this.loadingWmsVolume = false
          this.wmsOsVolumeData = {}
          this.$refs.qtdvolume.focus()
        })
      }
    },

    nomeStatusWms(stsIn){
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="wmsRomaData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>



    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start">




            <!--              <b-button variant="outline-primary" class="mx-2">-->
            <!--                <i class="bx bx-save font-size-16 align-middle me-2"></i>-->
            <!--                Salvar Alterações-->
            <!--              </b-button>-->


            <div class="flex-grow-1 align-self-center">
              <div class="text-muted">
                <h5>{{ wmsRomaOsListData !== null ? formatInteger(wmsRomaOsListData.length) : 0 }} pendente(s) de conferência</h5>
                <p class="mb-1">{{ wmsRomaOsListDataLidas !== null ? formatInteger(wmsRomaOsListDataLidas.length) : 0}} conferido(s) com sucesso</p>

              </div>
            </div>

            <div class="flex-grow-1 align-self-center">
              <div class="text-muted">
                <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                <!--                  <p class="mb-0">Id no: #SK0234</p>-->
              </div>
            </div>

            <b-button v-if="tipoVolume === 'I'"
                      variant="outline-primary" class="mx-2" @click="showModalVolume = true">
              <i class="bx bx-box font-size-16 align-middle me-2"></i>
              Volumes (alt + V)
            </b-button>

            <b-button variant="outline-warning" class="mx-2" @click="separarTodos">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Separar todos
            </b-button>

            <b-button variant="outline-primary" class="mx-2" @click="reiniciar">
              <i class="bx bx-sync font-size-16 align-middle me-2"></i>
              Reiniciar (alt + R)
            </b-button>

            <button class="btn btn-success" v-if="wmsRomaData.status === 'AB' || wmsRomaData.status === 'EL'" @click="finalizarNova">
              <i class="mdi mdi-check me-1 text-end"></i>
              Finalizar (alt + Z)
            </button>

          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="!updating">




      <div class="col-xl-2">
        <div class="card">
          <div class="card-body">

            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th class="text-start">Rom.</th>
                  <th class="text-start">Status</th>

                </tr>
                </thead>
                <tbody>

                <tr v-for="data in wmsRomaListData" :key="data.id">
                  <td class="text-start">
                    <a href="javascript: void(0);" class="text-body fw-bold  text-wrap" @click="abrirOutraOS(data.id)">
                      <h5 class="text-muted mb-0">{{ data.codigo }} </h5>
                      {{ data.id }}
                    </a>
                  </td>
                  <td class="text-start">
                      <span class="badge badge-pill badge-soft-success font-size-11"
                            :class="data.stswms === 'SE' ? 'badge-soft-success' : 'badge-soft-danger' ">
                        {{ nomeStatusWms(data.stsep)  }}
                      </span>
                    <p>
                      {{ formatInteger(data.qtdlida) }}
                      de
                      {{ formatInteger(data.qtd) }}
                    </p>

                    <p v-if="data.stsocor === 'A'">
                      <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-danger">
                        Ocorrência
                      </span>
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>

      <div class="col-xl-6">

        <b-card-text>
          <div class="card">
            <div class="card-body"

            >
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <form class="needs-validation" @submit.prevent="informouEtiquetaNova">
                <div class="row">

                  <div class="col-sm-12">
                    <div class="mb-3">
                      <label for="etiqueta">Etiqueta</label>
                      <input
                          id="etiqueta"
                          v-model="wmsOsVolumeData.etiqueta"
                          type="text"
                          ref="etiqueta"
                          class="form-control"
                          placeholder="Etiqueta"
                          :class="{'is-invalid': submitted && !wmsOsVolumeData.etiqueta}"/>
                      <div v-if="submitted && !wmsOsVolumeData.etiqueta"
                           class="invalid-feedback">
                        <span>Campo nome obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                </div>

              </form>


              <Loader v-if="updatingListas" style="min-height: 200px;">
              </Loader>

              <div class="row mt-5 mb-2" v-if="!updatingListas">

                <h4 class="card-title">Itens do romaneio para separação ({{ wmsRomaOsListData !== null ? wmsRomaOsListData.length : 0 }})</h4>

                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>

                      <th>Nota Fiscal</th>
                      <th>Etiqueta</th>
                      <th>Cliente</th>

                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in wmsRomaOsListData" :key="data.id">



                      <td  class="mt-2">
                        <h6 class="text-muted mb-0">{{ data.codigo  }} </h6>
                      </td>

                      <td  class="mt-2">
                        <a href="javascript: void(0);" class="text-body fw-bold text-wrap" @click="clicouEtiqueta(data.etiqueta)">
                          <h6 class="text-muted mb-0">{{ data.etiqueta  }} </h6>
                        </a>
                      </td>

                      <td  class="mt-2">
                        <h6 class="text-muted mb-0">{{ data.nome  }} </h6>
                      </td>

                    </tr>

                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </b-card-text>


      </div>


      <div class="col-xl-4">

        <b-card-text>
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <div class="row mb-2">

                <Loader v-if="updatingListas" style="min-height: 200px;">
                </Loader>

                <h4 class="card-title">Etiquetas lidas ({{ wmsRomaOsListDataLidas !== null ? wmsRomaOsListDataLidas.length : 0 }})</h4>

                <div class="table-responsive" v-if="!updatingListas">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th>Etiqueta</th>
                      <th>Nota Fiscal</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in wmsRomaOsListDataLidas" :key="data.id">


                      <td>
                        <h5 class="font-size-12 text-truncate">
                          <a href="javascript: void(0);" class="text-body fw-bold text-wrap" >
                            {{ data.etiqueta }}
                          </a>
                        </h5>

                        <h6 class="text-muted mb-0">{{ data.nome  }} </h6>

                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate">
                            {{ data.codigo }}
                        </h5>

                      </td>

                    </tr>

                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </b-card-text>


      </div>


    </div>


    <b-modal  size="lg"
              @shown="$refs.qtdvolume.focus()"
              title="Identificar Volume(s)" v-model="showModalVolume" centered hide-footer>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="quantidade">Quantidade</label>
            <input
                id="qtdvolume"
                ref="qtdvolume"
                v-model="wmsOsVolumeData.qtd"
                type="number"
                class="form-control text-end"
                @keypress.enter="informouQtdVolume"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="pesovolume">Peso</label>
            <input
                id="pesovolume"
                ref="pesovolume"
                v-model="wmsOsVolumeData.peso"
                type="number"
                class="form-control text-end"
                @keypress.enter="informouPeso"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

      </div>


      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col" class="">ID</th>
            <th scope="col" class="">Etiqueta</th>

            <th scope="col" class="text-end">Peso</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in wmsOsVolumesData" :key="data.id">

            <td>
              <div>
                <h5 class="text-truncate font-size-14">
                  {{ data.id }}
                </h5>
              </div>
            </td>

            <td class="text-info">
              <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)">
                <i class="mdi mdi-printer"></i>
                {{ data.etiqueta }}
              </a>
            </td>


            <td class="text-end">{{ formatDecimal(data.peso) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>
            </td>
            <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>
            </td>
            <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>
          </tr>

          </tbody>
        </table>
      </div>




      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVolume = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <!--          <b-button type="submit" variant="success" class="ms-1"-->
        <!--                    :disabled="this.wmsOsItemSepData.disp <= 0 || wmsOsItemSepData.qtd === 0 || wmsOsItemSepData.qtd > this.wmsOsItemSepData.disp || !wmsOsItemSepData.palete"-->
        <!--                    @click="confirmarSeparacao">-->
        <!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
        <!--            Confirmar-->
        <!--          </b-button>-->

        <b-button type="submit" variant="success" class="ms-1"
                  v-if="wmsOsVolumesData.length > 0"
                  @click="imprimirEtiquetas">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Imprimir Etiquetas
        </b-button>

        <b-button type="submit" variant="success" class="ms-1"
                  :disabled="!this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0 || !this.wmsOsVolumeData.peso || this.wmsOsVolumeData.peso <= 0 "
                  @click="confirmarVolume">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar Novo Volume
        </b-button>

      </div>
    </b-modal>

  </Layout>
</template>
